export const OTP_LENGTH = 6;
// Must match the backend's OTP_EXPIRE_SECONDS (app/config.py / .env) — this only
// drives the countdown UI shown to the patient, the backend is the real source
// of truth for when a code actually expires.
export const OTP_VALIDITY_SECONDS = 300;
export const OTP_EXPIRY_WARNING_SECONDS = 15;

/** A code's remaining lifetime as a sane countdown value: a whole number from 0
 *  to OTP_VALIDITY_SECONDS. A value outside that range (a malformed backend
 *  otpExpiresInSeconds, or a stale stored expiry) can't be a real remaining
 *  time, so it falls back to a fresh full window rather than showing a timer
 *  like "57031:58". */
export function saneOtpSeconds(seconds: number | null | undefined): number {
  if (typeof seconds !== "number" || !Number.isFinite(seconds) || seconds < 0 || seconds > OTP_VALIDITY_SECONDS) {
    return OTP_VALIDITY_SECONDS;
  }
  return Math.ceil(seconds);
}
